import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Sidebar from './components/sidebar';
import Login from './pages/login';
import User from './pages/user';
import Home from './pages/home';
import Comapny from './pages/company';
import Section from './pages/company/section';
import SectionLines from './pages/company/section/sectionline';
import Role from './pages/role';
import AuthGuard from './routes/AuthGuard';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="*" element={<h1>404 Not Found</h1>} />
        {/* Protected Routes */}
        <Route element={<AuthGuard redirectPath="/" />}>
          <Route
            element={
              <Sidebar>
                <Outlet />
              </Sidebar>
            }
          >
            <Route path="/home" element={<Home />} />
            <Route path="/users" element={<User />} />
            <Route path="/company" element={<Comapny />} />
            <Route path="/company/:company_id/sections" element={<Section />} />
            <Route path="/company/:company_id/sections/:section_id/section_lines" element={<SectionLines />} />
            <Route path="/roles" element={<Role />} />
            <Route path="*" element={<h1>404 Not Found</h1>} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
};

export default App;
